module.exports = __webpack_public_path__ + "static/img/chu2.11767fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/chu2.jpg
// module id = fmd3
// module chunks = 1